export default __webpack_public_path__ + "static/media/Sterling_Bank_Logo_Straight.1ad0d8d0.png";